import { IncidentManagementDetails } from './InterfacesServer';

export function validateIncidentActionDates(details: IncidentManagementDetails): string | null {
    if (details.correctiveAction?.trim() && !details.correctiveActionTargetCompletionDate) return 'Select a target completion date for the corrective action.';
    if (details.preventiveAction?.trim() && !details.preventiveActionTargetCompletionDate) return 'Select a target completion date for the preventive action.';
    return null;
}

export function validateIncidentClosure(status: string, details: IncidentManagementDetails): string | null {
    if (!details.correctiveAction?.trim() && !details.preventiveAction?.trim()) return 'Enter at least one corrective or preventive action.';
    const actionDateError = validateIncidentActionDates(details);
    if (actionDateError) return actionDateError;
    if (details.actionOwnerUserIds.length === 0) return 'Select at least one action owner.';
    if (details.riskRating == null) return 'Select a risk rating.';
    if (details.riskRating < 1 || details.riskRating > 6) return 'Risk rating must be between 1 and 6.';
    if (details.riskRegisterUpdated == null) return 'Answer whether the Risk Register was updated.';
    if (status !== 'PENDING_VERIFICATION') return 'The incident must be Pending Verification before closure can be requested.';
    return null;
}
